import { uploadData } from 'aws-amplify/storage';
import { Amplify } from 'aws-amplify';
import { awsConfig } from '../config/aws-export';

async function S3UploadHook(file,path) {
    Amplify.configure(awsConfig)
    const key = `${path}/${crypto.randomUUID()}/${file.name}`;

    try {
        const result = await uploadData({
            path: `public/${key}`,
            data: file,
            options: {
                contentType: file.type,
            },
        }).result;
        return result.path
    } catch (error) {
        console.log("error",error)

    }

}

export default S3UploadHook;